import { AutoGraph } from "@mui/icons-material";
import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AirlyPaySvg from "../../assets/images/AirlyPay";

const DashboardProductPurchase = ({ dashboardPaymentData }) => {
    const { t } = useTranslation();
    const dashboardData = [
        {
            title: "All orders",
            total: dashboardPaymentData && dashboardPaymentData.totalOrders,
            currency: "",
            icon: ""
        },
        {
            title: "Lump sum",
            total: dashboardPaymentData && dashboardPaymentData.totalRevenue,
            currency: "￥",
            icon: ""
        },
        {
            title: "Pending shipment",
            total: dashboardPaymentData && dashboardPaymentData.totalPendingShippings,
            currency: "",
            icon: <AirlyPaySvg />
        },
        {
            title: "Transactions in the past seven days",
            total: dashboardPaymentData && dashboardPaymentData.averageOrderValueLast7Days,
            currency: "￥",
            icon: ""
        }
    ]
    return (
        <Row >
            {
                dashboardData.map((item, ind) => (
                    <Col xs={24} sm={12} md={6} lg={6}>
                        <div className="d-flex" style={{ padding: "1.5rem 3rem", justifyContent: "space-between" }}>
                            <Row
                                className="text-center"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start"
                                }}
                            >
                                <Col className="titleCardNew14400 me-2">
                                    {t(item.title)} <span style={{marginLeft:"5px"}}>{item.title === "WeChat Pay" || item.title === "Alipay Payment" ? item.icon : ""}</span>
                                </Col>
                                <Col className="totalCard28500">
                                    <span className="currencyDashbord">{item.currency}</span>{item.total}
                                    {
                                        item.title === "New Users Per Day" || item.title === "日新增用户" || item.title === "Member Conversion Rate" || item.title === "会员转化率" ?
                                            <>
                                                <AutoGraph style={{ marginLeft: "10px", color: "#45b887" }} />
                                                <span style={{ fontSize: "16px", marginLeft: "10px", color: "#636e88" }}>{item.rate}%</span>
                                            </>
                                            : ""
                                    }
                                </Col>
                            </Row>
                            {
                                item.title === "Transactions in the past seven days" || item.title === "近七日成交" ? "" :
                                    <div className="vr" style={{ height: "70px", borderLeft: "1px solid #000" }}></div>
                            }
                        </div>
                    </Col>
                ))
            }
        </Row>
    );
};

export default DashboardProductPurchase;
